import React, { Component } from "react";
import Dialog from "@material-ui/core/Dialog";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import ChevronLeft from "@material-ui/icons/ChevronLeft";
import ChevronRight from "@material-ui/icons/ChevronRight";
import COLORS from "../theme/colors";

/** Base64 from the order (signatures are PNG, photos JPEG) as an <img> source. */
export const toImageSrc = (value, mime = "image/jpeg") =>
  String(value).startsWith("data:") ? value : `data:${mime};base64,${value}`;

const styles = {
  paper: { position: "relative", maxWidth: "92vw", maxHeight: "92vh", margin: 16, borderRadius: 14, overflow: "hidden" },
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 12,
    padding: "10px 8px 10px 20px",
    borderBottom: `1px solid ${COLORS.border}`
  },
  title: { color: COLORS.text, fontSize: 16, fontWeight: 600 },
  counter: { marginLeft: 10, color: COLORS.muted, fontSize: 14, fontWeight: 400 },
  stage: {
    position: "relative",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    minWidth: 320,
    minHeight: 200,
    background: COLORS.field
  },
  image: { display: "block", maxWidth: "88vw", maxHeight: "78vh", objectFit: "contain" },
  nav: {
    position: "absolute",
    top: "50%",
    transform: "translateY(-50%)",
    background: "rgba(255,255,255,0.92)",
    boxShadow: "0 2px 8px rgba(31,41,51,0.18)"
  }
};

/**
 * Shows one image of `images` ([{ src, title }]) large, with previous/next when there are several.
 * Arrow keys move between images, Esc closes.
 */
class ImageLightbox extends Component {
  componentDidMount() {
    window.addEventListener("keydown", this.handleKey);
  }

  componentWillUnmount() {
    window.removeEventListener("keydown", this.handleKey);
  }

  handleKey = e => {
    if (this.props.index === null || this.props.index === undefined) return;
    if (e.key === "ArrowLeft") this.move(-1);
    if (e.key === "ArrowRight") this.move(1);
  };

  move = step => {
    const { images, index, onChange } = this.props;
    if (images.length < 2) return;
    onChange((index + step + images.length) % images.length);
  };

  render() {
    const { images, index, onClose } = this.props;
    const open = index !== null && index !== undefined && Boolean(images[index]);
    const current = open ? images[index] : null;
    const several = images.length > 1;

    return (
      <Dialog open={open} onClose={onClose} maxWidth={false} PaperProps={{ style: styles.paper }}>
        {current && (
          <div>
            <div style={styles.header}>
              <div style={styles.title}>
                {current.title}
                {several && <span style={styles.counter}>{index + 1} / {images.length}</span>}
              </div>
              <IconButton aria-label="Zapri" onClick={onClose}>
                <CloseIcon />
              </IconButton>
            </div>
            <div style={styles.stage}>
              <img src={current.src} alt={current.title} style={styles.image} />
              {several && (
                <IconButton aria-label="Prejšnja slika" onClick={() => this.move(-1)} style={{ ...styles.nav, left: 12 }}>
                  <ChevronLeft />
                </IconButton>
              )}
              {several && (
                <IconButton aria-label="Naslednja slika" onClick={() => this.move(1)} style={{ ...styles.nav, right: 12 }}>
                  <ChevronRight />
                </IconButton>
              )}
            </div>
          </div>
        )}
      </Dialog>
    );
  }
}

export default ImageLightbox;
